/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import {
  rem,
  createTheme,
  Input as MantineInput,
  type MantineTheme,
  type InputCssVariables,
} from '@mantine/core';

import { typographyToken, variablesToken } from '@fai/design-tokens';

import * as classes from './input.css';

export const inputTheme = createTheme({
  components: {
    Input: MantineInput.extend({
      defaultProps: { size: 'sm' },
      vars: (_, { size }) => {
        const wrapper: Partial<Record<InputCssVariables['wrapper'], string>> = {
          '--input-fz': typographyToken.body['typography-body-md'].fontSize,
          '--input-height': size === 'xs' ? rem(32) : rem(40),
          '--input-right-section-width': rem(36),
          '--input-left-section-width': rem(36),
          '--input-radius': variablesToken.radius.sm,
        };

        return { wrapper };
      },
      classNames: (_, props) => ({
        input: props.disabled
          ? classes.inputDisabled
          : props.error
          ? classes.inputError
          : classes.input,
      }),
    }),
  },
}) as MantineTheme;
